module.exports = __webpack_public_path__ + "img/acqua-palace_piscine_a_vagues.40fcdb10.jpeg";